<app-template-search [disabled]="disabled" [value]="value" [control]="control" [groups]="groups" [options]="options" [label]="label" />
